import axiosInstance from "./axiosInstance";

export default class ApiService {
  static abortControllers = new Map();

  static async request(method, url, body, config = {}) {
    const skipCancel = config.skipCancelToken === true;

    // Abort previous request only if not skipped
    if (!skipCancel && this.abortControllers.has(url)) {
      const existingController = this.abortControllers.get(url);
      existingController?.abort();
    }

    const controller = new AbortController();

    // Only store controller if not skipped
    if (!skipCancel) {
      this.abortControllers.set(url, controller);
    }

    try {
      const response = await axiosInstance({
        method,
        url,
        data: body,
        ...config,
        headers: {
          ...config.headers,
        },
        // A caller's own signal (e.g. a cancellable upload) wins over the per-URL one
        signal: config.signal || controller.signal,
      });

      return response.data;
    } catch (err) {
      if (err.name === "AbortError") {
        console.log(`Request aborted: ${url}`);
      }
      throw err;
    } finally {
      if (!skipCancel && this.abortControllers.get(url) === controller) {
        this.abortControllers.delete(url);
      }
    }
  }

  static get(url, config) {
    return this.request("get", url, undefined, config);
  }

  static post(url, body, config) {
    return this.request("post", url, body, config);
  }

  static put(url, body, config) {
    return this.request("put", url, body, config);
  }

  static delete(url, config) {
    return this.request("delete", url, undefined, config);
  }
}
